import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
} from "@material-ui/core";
import { FC } from "react";
import { useStyles } from "../styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { SHIFT_REPORT_TABLE_HEADERS_COLUMNS } from "../tableData";
import { ShiftrReportsRow } from "./ShiftrReportsRow";
import PaginationSwitch from "componentsNew/elements/PaginationSwitch";
import { useDispatch } from "react-redux";
import { shiftTrackerUpdateFilters } from "actions/shiftTrackerActions";

interface PropsType {}

const ShiftTrackerListTable: FC<PropsType> = () => {
  const classes = useStyles();
  const { userData } = useTypeSelectors((state) => state.auth);
  const { reportList, reportListFilters, reportListCount } = useTypeSelectors(
    (state) => state.dasBoard,
  );
  const dispatch = useDispatch();

  const handleChangePagination = (event: unknown, value: number) => {
    dispatch(shiftTrackerUpdateFilters({ pageNumber: Number(value) }));
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(shiftTrackerUpdateFilters({ rowsPerPage: Number(event.target.value) }));
  };

  return (
    <>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            {SHIFT_REPORT_TABLE_HEADERS_COLUMNS?.map((col: any) => (
              <TableCell key={col.id} className={`${classes.tableHeadCell}`}>
                <Box className={classes.tableCellContent}>
                  <Typography className={classes.tableHeadCellText}>{col.label}</Typography>
                </Box>
              </TableCell>
            ))}
          </TableHead>
          <TableBody>
            {reportList.map((report) => (
              <ShiftrReportsRow row={report} userRole={userData.role} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box className={classes.tableFooter}>
        <PaginationSwitch
          page={reportListFilters?.pageNumber}
          rowsPerPage={reportListFilters?.rowsPerPage}
          totalPages={reportListCount}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleChangePage={handleChangePagination}
        />
      </Box>
    </>
  );
};

export default ShiftTrackerListTable;
